const getFactionIconName = (name?: string) => `fa-kit fa-${name?.substring(0, 2).toLocaleLowerCase()}`;

export default getFactionIconName;
